import { Moment } from "moment";
import {
  IOfferAggRuleFormData,
  IOfferParamsFormData,
  IOfferTarifficationFormData,
  IOfferServiceProfileFormData,
} from "../../context/types";
import { toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../../../lib/utils";
import LocalStorageService from "../../../../services/LocalStorageService";
import { IServiceProfile, Offer } from "../../../../lib/types";
import { getServiceRatesBody } from "./getServiceRatesBody";
import { getAggregationRulesBody } from "./getAggregationRulesBody";
import { TableDataCharacteristic } from "../../../../modules/policies/features/CharacteristicsTable/CharacteristicsTableTypes";
import { getCharFormatItem } from "../../../../modules/policies/services/getCharFormatItem";

interface Params {
  offerValues: IOfferParamsFormData<Moment>;
  tarifficationValues: IOfferTarifficationFormData<Moment>;
  aggregationRulesValues: IOfferAggRuleFormData;
  serviceProfileValues: IOfferServiceProfileFormData<Moment>;
  isCommonOfferingType: boolean;
  infoCharacteristic: TableDataCharacteristic[];
  charValuesCharacteristic: TableDataCharacteristic[];
  productCharValuesCharacteristic: TableDataCharacteristic[];
  serviceTypeId: number | undefined;
}

export const getOfferCreateBody = (params: Params): Offer<string, "createObj"> => {
  const {
    offerValues,
    aggregationRulesValues,
    tarifficationValues,
    serviceProfileValues,
    isCommonOfferingType,
    infoCharacteristic,
    charValuesCharacteristic,
    productCharValuesCharacteristic,
    serviceTypeId,
  } = params;
  const fromDate = toHttpFormatStartOfDay(offerValues.fromDate);
  const toDate = offerValues.toDate && toHttpFormatEndOfDay(offerValues.toDate);
  const tenantId = Number(LocalStorageService.getTenantId());

  const serviceProfile: Partial<IServiceProfile> = isCommonOfferingType
    ? { id: serviceProfileValues.id, profileTypeId: serviceProfileValues.profileTypeId }
    : {
        name: `Для предложения ${offerValues.name}`,
        profileTypeId: serviceProfileValues.profileTypeId,
        paymentTypeId: serviceProfileValues.paymentTypeId,
        invoicePeriodId: serviceProfileValues.invoicePeriodId,
        prepaymentPeriodId: serviceProfileValues.prepaymentPeriodId,
        prepaymentToPayDays: serviceProfileValues.prepaymentToPayDays,
        billToPayDays: serviceProfileValues.billToPayDays,
        billPeriodId: serviceProfileValues.billPeriodId,
        fromDate,
        tenantId,
      };

  const serviceRates = getServiceRatesBody({
    tarifficationValues,
    fromDate,
    forAggregationRule: false,
  });
  const aggregationRules = getAggregationRulesBody({
    aggregationRulesValues,
    fromDate,
    tarifficationValues,
  });

  const info = infoCharacteristic.map((el) => getCharFormatItem(el, 1043));
  const charValues = charValuesCharacteristic.map((el) => getCharFormatItem(el));
  const productCharValues = productCharValuesCharacteristic.map((el) =>
    getCharFormatItem(el, 1032)
  );

  const createdOffer: Offer<string, "createObj"> = {
    extName: offerValues.extName,
    name: offerValues.name,
    serviceTypeId,
    offeringTypeId: offerValues.offeringTypeId,
    agreementId: offerValues.agreementId,
    prolongTypeId: offerValues.prolongTypeId,
    lifespanPeriodId: offerValues.lifespanPeriodId,
    lifespanPeriodQty: offerValues.lifespanPeriodQty,
    isStandalone: offerValues.isStandalone,
    offeringStatusId: offerValues.offeringStatusId,
    bundleTypeId: offerValues.bundleTypeId,
    tariffModelId: offerValues.tariffModelId,
    periodAlignmentId: offerValues.periodAlignmentId,
    fromDate,
    serviceRates,
    aggregationRules,
    serviceProfile,
    info,
    charValues,
    productCharValues,
  };

  if (toDate) {
    createdOffer.toDate = toDate;
    createdOffer.serviceRates = createdOffer.serviceRates?.map((rate) => ({ ...rate, toDate }));
    if (!isCommonOfferingType) {
      serviceProfile.toDate = toDate;
    }
  }
  return createdOffer;
};
